<template>
  <div class="check-container container">
    <span class="basic-title">院内准备：</span>
    <div class="detail-info check-info substance">
      <span class="info-title">相关检查：</span>
      <div v-if="isShowPatient" style="display: inline-block">
        <!-- 展示页面,不能做任何修改 -->
        <el-radio
          v-model="patient.bloodTest"
          label="验血"
          :disabled="isShowPatient"
        >验血
        </el-radio>
        <el-radio
          v-model="patient.xRay"
          label="胸透"
          :disabled="isShowPatient"
        >胸透
        </el-radio>
        <el-radio
          v-model="patient.gastroscopy"
          label="肠胃镜"
          :disabled="isShowPatient"
        >肠胃镜
        </el-radio>
        <el-radio
          v-model="patient.Xlight"
          label="X光"
          :disabled="isShowPatient"
        >X光
        </el-radio>
      </div>

      <div v-else style="display: inline-block">
        <!-- 编辑页面,可以修改 -->
        <el-checkbox v-model="checkForm.bloodTest">验血</el-checkbox>
        <el-checkbox v-model="checkForm.xRay">胸透</el-checkbox>
        <el-checkbox v-model="checkForm.gastroscopy">肠胃镜</el-checkbox>
        <el-checkbox v-model="checkForm.Xlight">X光</el-checkbox>
      </div>
    </div>
    <div class="detail-info check-info substance">
      <span class="info-title">病房：</span>
      <div v-if="isShowPatient" style="display: inline-block">
        <!-- 展示页面,不能做任何修改 -->
        <el-radio
          v-model="patient.room"
          label="急诊手术室"
          :disabled="isShowPatient"
        >急诊手术室
        </el-radio>
        <el-radio
          v-model="patient.room"
          label="急诊EICU"
          :disabled="isShowPatient"
        >急诊EICU
        </el-radio>
        <el-radio
          v-model="patient.room"
          label="急诊综合病房"
          :disabled="isShowPatient"
        >急诊综合病房
        </el-radio>
      </div>

      <div v-else style="display: inline-block">
        <!-- 编辑页面,可以修改 -->
        <el-radio v-model="checkForm.room" label="急诊手术室">急诊手术室</el-radio>
        <el-radio v-model="checkForm.room" label="急诊EICU">急诊EICU</el-radio>
        <el-radio v-model="checkForm.room" label="急诊综合病房">急诊综合病房</el-radio>
      </div>
      <div>
        <el-button v-if="isAddPatient" @click="orderDrug">下单</el-button>
      </div>

      <div class="detail-info hospital-info">
        <span class="info-key">准备内容：</span>
        <!-- 展示页面 -->
        <span v-if="isShowPatient" class="info-item">{{ patient.operation }} </span>
        <!-- 补写页面 -->
        <el-input
          v-else
          v-model="checkForm.operation"
          class="operationInput"
          placeholder=""
          type="textarea"
          resize="none"
          :rows="6"
        />
      </div>
    </div>
    <!--  下单弹窗验证-->
    <confirm-order
      v-if="showCheckOrderDialog"
      :change-pwd.sync="showCheckOrderDialog"
      @checkOrder="checkAndOrder"
      @closeChangeForm="showCheckOrderDialog=false"
    />
    <my-dialog
      :dialog-carted="infoDialog"
      :form-title="dialogTitle"
      :width="320"
      @confirmOk="infoDialog = false"
    >
      <template #content>
        <div>{{ dialogMessage }}</div>
      </template>
    </my-dialog>
  </div>
</template>
<script>
import { addPatient } from "@/api/hospitalList";
import { checkUserForOrder } from "@/api/user.js";
import MyDialog from "@components/customDialog/MyDialog.vue";
import ConfirmOrder from "@components/customDialog/ConfirmOrder";
import { mapState } from "vuex";
import md5 from "js-md5";
import { showWindowMessage } from "@utils/notification";

export default {
  name: "Check",
  components: {
    ConfirmOrder,
    MyDialog
  },
  data() {
    return {
      checkForm: { // 不能注释, 必须要存在, 否则报错
        bloodTest: false, // 验血
        xRay: false, // 胸透
        gastroscopy: false, // 肠胃镜
        Xlight: false, // 核磁共振
        room: "",
        id: "",
        method: "changeMedicalhistory"
      },
      showCheckOrderDialog: false, // 下单弹窗验证
      infoDialog: false, // 下单成功提示 确定
      dialogTitle: "提示", // 确定框 的标题
      dialogMessage: "下单成功" // 确定框 文字信息
    };
  },
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo",
      userInfo: "userInfo"
    }),
    isShowPatient() {
      return this.patient?.pageInfo?.isShowPatient;
    },
    isAddPatient() {
      return this.patient?.pageInfo?.isAddPatient;
    },
    isWriteMore() {
      return this.patient?.pageInfo?.isWriteMore;
    },
  },
  watch: {
    patient: {
      handler(val) {
        const { room, prepare, check: Check, id } = val;
        this.patient.bloodTest = Check.indexOf("验血") !== -1 ? "验血" : "";
        this.patient.xRay = Check.indexOf("胸透") !== -1 ? "胸透" : "";
        this.patient.gastroscopy = Check.indexOf("肠胃镜") !== -1 ? "肠胃镜" : "";
        this.patient.Xlight = Check.indexOf("X光") !== -1 ? "X光" : "";
        this.checkForm = {
          bloodTest: Check.indexOf("验血") !== -1,
          xRay: Check.indexOf("胸透") !== -1,
          gastroscopy: Check.indexOf("肠胃镜") !== -1,
          Xlight: Check.indexOf("X光") !== -1,
          room,
          operation: prepare,
          id,
          method: "changeMedicalhistory"
        };
      },
      immediate: true
    }
  },

  methods: {
    /**
     * 下单检测
     * 1. 医生 直接发送请求
     * 2. 非医生 弹窗验证后发送
     * */
    async orderDrug() {
      const role = this.userInfo.loginUserId;
      if (role !== "2") {
        this.showCheckOrderDialog = true;
      } else {
        await this.saveFormData();
      }
    },
    /**
     * 向后台请求 下单
     * */
    async checkAndOrder(data) {
      try {
        data.password = md5(data.password, 32); // MD5加密
        const { code, msg } = await checkUserForOrder(data);
        if (code === 200) {
          await this.saveFormData();
        } else {
          this.dialogTitle = "警告";
          this.dialogMessage = msg;
          this.infoDialog = true;
        }
      } catch (e) {
        showWindowMessage(3, e, this);
      }
    },
    /**
     * 真正保存信息
     * */
    async saveFormData(data) {
      const {
        bloodTest, xRay, Xlight, gastroscopy, room, operation: prepare, method, id
      } = this.checkForm;
      const checkList = [];
      if (bloodTest) {
        checkList.push("验血");
      }
      if (xRay) {
        checkList.push("胸透");
      }
      if (gastroscopy) {
        checkList.push("肠胃镜");
      }
      if (Xlight) {
        checkList.push("X光");
      }
      const checkString = checkList.join("/");
      const data1 = {
        id: id,
        check: checkString,
        room,
        prepare,
        method
      };
      const { code, msg } = await addPatient(data1);
      this.dialogTitle = code === 200 ? "提示" : "警告";
      this.dialogMessage = msg;
      this.infoDialog = true;
      this.showCheckOrderDialog = false;
    }
  }
};
</script>
<style scoped lang="scss">
.check-container {
}

.check-info {
  padding-top: 12px; // 分区信息标题(已经缩了12px了)
  .el-button {
    width: 64px;
    height: 32px;
    min-height: 32px;
    border: 1px solid #2AA5E3;
    border-radius: 10px;
    font-size: 16px;
    color: #2AA5E3;
    padding-top: 9px;
    padding-left: 14px;
  }
}

.detail-info {
  height: auto;
}

.hospital-info {
  height: auto;
  padding-top: 12px; // 分区信息标题(已经缩了12px了)
  position: relative;
}

.operationInput {
  width: 800px;
  padding-left: 24px;
}
</style>
